import type { GenerationCostGuardReason } from "./generation-cost-policy";

/**
 * Mensagens do guarda de custos. Cada motivo tem de dizer a VERDADE:
 * "já está a ser criado" só se aplica a um pedido igual em curso — nunca a um
 * limite horário, que é o que confundia quem testava destinos diferentes.
 */
export function generationGuardCopy(
  reason: GenerationCostGuardReason,
  wait: string,
  lang: string,
): string {
  const l = (lang || "pt").toLowerCase().slice(0, 2);
  const pick = (pt: string, en: string, es: string, fr: string, de: string, it: string) =>
    l === "pt" ? pt : l === "es" ? es : l === "fr" ? fr : l === "de" ? de : l === "it" ? it : en;

  if (reason === "in_progress" || reason === "duplicate") {
    return pick(
      `Este pedido igual ainda está a ser criado. Espera ${wait} ou muda algo no pedido — não gastaste créditos.`,
      `This same request is still being created. Wait ${wait} or change something — no credits used.`,
      `Esta misma petición sigue creándose. Espera ${wait} o cambia algo — no gastaste créditos.`,
      `Cette même demande est encore en cours. Attends ${wait} ou modifie-la — aucun crédit utilisé.`,
      `Dieselbe Anfrage wird noch erstellt. Warte ${wait} oder ändere etwas — keine Credits verbraucht.`,
      `Questa stessa richiesta è ancora in corso. Aspetta ${wait} o modificala — nessun credito speso.`,
    );
  }
  if (reason === "attempt_limit") {
    return pick(
      `Atingiste o limite de pedidos por hora. Podes voltar a criar rotas dentro de ${wait} — não gastaste créditos.`,
      `You reached the hourly request limit. You can create routes again in ${wait} — no credits used.`,
      `Alcanzaste el límite de peticiones por hora. Podrás crear rutas en ${wait} — no gastaste créditos.`,
      `Tu as atteint la limite horaire de demandes. Tu pourras créer des itinéraires dans ${wait} — aucun crédit utilisé.`,
      `Du hast das Stundenlimit erreicht. In ${wait} kannst du wieder Routen erstellen — keine Credits verbraucht.`,
      `Hai raggiunto il limite orario di richieste. Potrai creare percorsi tra ${wait} — nessun credito speso.`,
    );
  }
  if (reason === "failure_limit" || reason === "provider_circuit_open") {
    return pick(
      `Houve falhas técnicas seguidas e travámos os pedidos para te proteger. Tenta dentro de ${wait} — não gastaste créditos.`,
      `Repeated technical failures paused new requests to protect you. Try again in ${wait} — no credits used.`,
      `Hubo fallos técnicos seguidos y pausamos las peticiones. Inténtalo en ${wait} — no gastaste créditos.`,
      `Des erreurs techniques répétées ont mis les demandes en pause. Réessaie dans ${wait} — aucun crédit utilisé.`,
      `Wiederholte technische Fehler haben Anfragen pausiert. Versuche es in ${wait} — keine Credits verbraucht.`,
      `Errori tecnici ripetuti hanno messo in pausa le richieste. Riprova tra ${wait} — nessun credito speso.`,
    );
  }
  return pick(
    `Não foi possível iniciar agora. Tenta dentro de ${wait} — não gastaste créditos.`,
    `Couldn't start right now. Try again in ${wait} — no credits used.`,
    `No se pudo iniciar ahora. Inténtalo en ${wait} — no gastaste créditos.`,
    `Impossible de démarrer maintenant. Réessaie dans ${wait} — aucun crédit utilisé.`,
    `Start derzeit nicht möglich. Versuche es in ${wait} — keine Credits verbraucht.`,
    `Impossibile iniziare ora. Riprova tra ${wait} — nessun credito speso.`,
  );
}
